import { ImageApiUrl, PdfApiUrl } from "./Additional";

export const fileConverterHandler = async (File, Id, FolderName) => {
  const form = new FormData();

  form.append("file", File);
  form.append("foldername", `Job/${FolderName}`);
  form.append("filename", `${FolderName}-${Id}`);

  let res = await fetch(PdfApiUrl, {
    method: "POST",
    body: form,
  });
  let result = await res.json();
  const parsed = new URL(result.Message);
  return parsed.pathname.substring(1) + parsed.search;
};
export const imageConverterHandler = async (File, Id, FolderName) => {
  const form = new FormData();

  form.append("file", File);
  form.append("foldername", `Job/${FolderName}`);
  form.append("filename", `${FolderName}-${Id}`);
  let res = await fetch(ImageApiUrl, {
    method: "POST",
    body: form,
  });
  let result = await res.json();
  const parsed = new URL(result.Message);
  return parsed.pathname.substring(1) + parsed.search;

  // fetch(, {
  //   method: "POST",
  //   body: form,
  // })
  //   .then((res) => res.json())
  //   .then((result) => {
  //     setImagePreviewUrl(result?.Message);
  //   });
};
